import SubcategoryPage from '@/components/template/SubcategoryPage';

const Eclisse = () => {
  const products = [
    {
      title: "Eclisse Model 1",
      imageSrc: "https://images.unsplash.com/photo-1616627052149-fe43712e633e?auto=format&fit=crop&q=80",
      url: "/ogledala/eclisse/model-1"
    },
    {
      title: "Eclisse Model 2",
      imageSrc: "https://images.unsplash.com/photo-1603204077587-a3e570be71a9?auto=format&fit=crop&q=80",
      url: "/ogledala/eclisse/model-2"
    },
    {
      title: "Eclisse Model 3",
      imageSrc: "https://images.unsplash.com/photo-1618137221617-50988a8254f4?auto=format&fit=crop&q=80",
      url: "/ogledala/eclisse/model-3"
    },
    {
      title: "Eclisse Model 4",
      imageSrc: "https://images.unsplash.com/photo-1556911220-bda9f7f6b548?auto=format&fit=crop&q=80",
      url: "/ogledala/eclisse/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Eclisse"
      description="Edinstvena ogledala z inovativno zasnovo, ki spominja na mrk. Igra svetlobe in senc za sodoben dom."
      heroImage="https://images.unsplash.com/photo-1616627052149-fe43712e633e?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Eclisse;